import { useQuery } from '@tanstack/react-query';
import ContentApiService from '@jwp/ott-common/src/services/ContentApiService';
import { getModule } from '@jwp/ott-common/src/modules/container';
import { useConfigStore } from '@jwp/ott-common/src/stores/ConfigStore';

export const useSeriesLookup = (mediaId: string | undefined) => {
  const contentApiService = getModule(ContentApiService);
  const config = useConfigStore.getState().config;

  const { isLoading, data } = useQuery({
    queryKey: ['seriesLookup', mediaId],
    queryFn: async () => {
      if (!mediaId) {
        return null;
      }

      // get all series for the given media id
      const data = await contentApiService.getSeriesByMediaIds({ mediaIds: [mediaId], config });
      // get first series for the requested episode
      return data?.[mediaId]?.[0] || null;
    },
    enabled: !!mediaId,
  });

  return {
    isLoading,
    data: data || undefined, // many components use the legacy `undefined`
  };
};
